import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';
import throttle from 'lodash/throttle';
import getRemBase from 'propel/getRemBase';
import { checkElementInView } from 'propel/checkElementInView';

const sliders = document.querySelectorAll('.block-card-scroll .swiper');
const cardBlocks = document.querySelectorAll('.block-card-scroll-card');
const swiperInstances = [];
const blocksAtTop = {};

const initializeSliders = () => {
	if (window.innerWidth >= 768) {
		swiperInstances.forEach((swiperInstance) => {
			swiperInstance.destroy(true, true);
		});

		swiperInstances.length = 0;

		return;
	} else if (swiperInstances.length > 0) {
		return;
	}

	if (sliders.length > 0) {
		sliders.forEach((slider, index) => {
			const slides = slider.querySelectorAll('.swiper-slide');

			slider
				.closest('.block-card-scroll')
				.classList.add(`block-card-scroll--${index}`);

			const settings = {
				loop: slides.length > 1 ? true : false,
				grabCursor: true,
				spaceBetween: 5,
				slidesPerView: 1,
				modules: [A11y, Navigation, Pagination],
				a11y: {
					itemRoleDescriptionMessage: 'slide',
				},
				navigation: {
					prevEl: `.block-card-scroll--${index} .swiper-button-prev`,
					nextEl: `.block-card-scroll--${index} .swiper-button-next`,
				},
				pagination: {
					el: `.block-card-scroll--${index} .swiper-pagination`,
					clickable: true,
				},
			};

			swiperInstances.push(new Swiper(slider, settings));
		});
	}
};

const setBlockOffset = () => {
	cardBlocks.forEach((block) => {
		let blockOffset = window.innerHeight - block.offsetHeight;

		if (blockOffset > 0) {
			blockOffset = 0;
		}

		block.style.setProperty(
			'--blockOffset',
			`${blockOffset / getRemBase()}rem`
		);
	});
};

const watchBlockScroll = () => {
	if (0 === Object.keys(blocksAtTop).length) {
		return;
	}

	Object.entries(blocksAtTop).forEach(([index, block]) => {
		const rect = block.getBoundingClientRect();
		let blockDistanceFromTopofViewport = rect.top - 64;

		if (blocksAtTop[parseInt(index) + 1]) {
			block.classList.add('block-card-scroll-card--scrolled');
		} else {
			block.classList.remove('block-card-scroll-card--scrolled');
		}

		if (blockDistanceFromTopofViewport < 0) {
			blockDistanceFromTopofViewport = 0;
		}

		let blockScale =
			blockDistanceFromTopofViewport / (window.innerHeight / 2);

		if (blockScale > 1) {
			blockScale = 1;
		}

		const previousBlockOpacity = blockScale;
		blockScale = 0.9 + blockScale * 0.1;

		block.style.setProperty('--blockScale', blockScale);

		if (blocksAtTop[index - 1]) {
			const previousBlock = blocksAtTop[index - 1];

			previousBlock.style.setProperty('--opacity', previousBlockOpacity);
		}
	});
};

const atTop = (block) => {
	block.classList.add('block-card-scroll-card--at-top');

	blocksAtTop[block.getAttribute('data-index')] = block;
};

const notAtTop = (block) => {
	block.classList.remove('block-card-scroll-card--at-top');

	delete blocksAtTop[block.getAttribute('data-index')];
};

cardBlocks.forEach((block, index) => {
	block.setAttribute('data-index', index);

	checkElementInView(block, atTop, notAtTop, {
		root: null,
		rootMargin: '0px 0px -50% 0px',
		threshold: [0],
	});
});

initializeSliders();
setBlockOffset();
watchBlockScroll();

window.addEventListener('propel-viewport-changed-md', initializeSliders);
window.addEventListener('propel-viewport-changed-lg', initializeSliders);
window.addEventListener('resize', throttle(setBlockOffset, 100));
window.addEventListener('scroll', throttle(watchBlockScroll, 10));
